export const doctorsTypes = {
    FETCH_DOCTORS_INFO_START:'FETCH_DOCTORS_INFO_START',
    SET_DOCTORS_INFO_START:'SET_DOCTORS_INFO_START',
    SET_DOCTOR_INFO_START:'SET_DOCTOR_INFO_START',
    GET_DOCTOR_INFO_START:'GET_DOCTOR_INFO_START',
    ADD_DOCTOR_INFO_START:'ADD_DOCTOR_INFO_START',
    UPDATE_DOCTOR_INFO_START:'UPDATE_DOCTOR_INFO_START'
} 